import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div className="max-w-[1100px] mx-auto px-5 md:px-10 py-16 md:py-24">
      {/* Header */}
      <div className="max-w-3xl mb-16">
        <div className="ie-overline text-brand-accent mb-4">
          Legal
        </div>

        <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl tracking-tight leading-[1.05]">
          Privacy Policy
        </h1>

        <p className="text-text-secondary text-sm mt-5">
          Your privacy matters to us. This policy explains how INDUS EIRENE
          collects, uses and protects information when you use our website.
        </p>

        <p className="ie-overline text-text-secondary mt-5">
          Last updated · September 2026
        </p>
      </div>

      {/* Content */}
      <div className="max-w-3xl space-y-12 text-sm leading-7 text-text-secondary">

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            1. Information We Collect
          </h2>

          <p>
            When you place an order, create an account, contact us or otherwise
            use our services, we may collect information such as your name,
            email address, phone number, delivery address and order details.
          </p>

          <p className="mt-4">
            We may also collect basic technical information required to operate
            and improve our website, such as browser information, device
            information and website usage data.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            2. How We Use Your Information
          </h2>

          <p>
            We use the information we collect to process and deliver orders,
            provide customer support, manage your account, communicate with you
            about your orders and improve our website and services.
          </p>

          <p className="mt-4">
            If you subscribe to our newsletter, we may use your email address
            to send you updates, stories and selected information from
            INDUS EIRENE. You can unsubscribe from marketing communications at
            any time.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            3. Payments
          </h2>

          <p>
            Payments made through our website are processed by our payment
            service provider. We do not store your complete card number,
            CVV or other sensitive payment credentials on our servers.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            4. Sharing of Information
          </h2>

          <p>
            We may share necessary information with trusted service providers
            who help us operate the business, including payment processing,
            shipping and delivery, website infrastructure and customer
            communications.
          </p>

          <p className="mt-4">
            We do not sell your personal information to third parties.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            5. Data Security
          </h2>

          <p>
            We take reasonable technical and organisational measures to
            protect information against unauthorised access, alteration,
            disclosure or destruction. However, no method of transmission or
            electronic storage can be guaranteed to be completely secure.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            6. Your Choices
          </h2>

          <p>
            You may contact us if you want to access, update or correct
            information associated with your account or order, subject to
            applicable legal requirements.
          </p>

          <p className="mt-4">
            You can also choose not to receive promotional communications from
            us by using the unsubscribe option included in those messages.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            7. Children's Privacy
          </h2>

          <p>
            Our website is intended for general consumer use. We do not
            knowingly collect personal information from children where such
            collection is prohibited by applicable law.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            8. Changes to This Policy
          </h2>

          <p>
            We may update this Privacy Policy from time to time to reflect
            changes to our services, technology or legal requirements. Any
            updated version will be published on this page.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            9. Contact Us
          </h2>

          <p>
            If you have questions about this Privacy Policy or how your
            information is handled, please contact us.
          </p>

          <div className="mt-5 border border-border p-5">
            <div className="ie-overline text-foreground mb-2">
              INDUS EIRENE
            </div>

            <a
              href="mailto:care@induseirene.in"
              className="text-foreground hover:text-brand-accent transition-colors"
            >
              care@induseirene.in
            </a>

            <p className="mt-2">
              Atelier · Madhya Pradesh · India
            </p>
          </div>
        </section>

      </div>

      {/* Bottom navigation */}
      <div className="max-w-3xl mt-16 pt-8 border-t border-border flex flex-wrap gap-5">
        <Link
          to="/terms"
          className="ie-btn-ghost"
        >
          Terms & Conditions
        </Link>

        <Link
          to="/shipping"
          className="ie-btn-ghost"
        >
          Shipping
        </Link>

        <Link
          to="/returns"
          className="ie-btn-ghost"
        >
          Returns
        </Link>
      </div>
    </div>
  );
}